import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CampagneUser, CampagneUserEntityState } from '@get/api-interfaces';
import { CampagneUserRelationsIds } from '@get/store/ids-interfaces';

export const CampagneUserGeneratedActions = createActionGroup({
  source: 'Campagne User Generated',
  events: {
    'Get One Campagne User': props<{ idCampagneUser: number; params?: any }>(),
    'Get Many Campagne Users': props<{ params: any }>(),
    'Add Many Actives Campagne Users': props<{ idCampagneUsers: number[] }>(),
    'Delete One Active Campagne User': props<{ idCampagneUser: number }>(),
    'Clear Actives Campagne Users': emptyProps(),
    'Upsert One Campagne User': props<{ campagneUser: Partial<CampagneUser>; ids?: CampagneUserRelationsIds; }>(),
    'Upsert Many Campagne Users': props<{ campagneUsers: Partial<CampagneUser>[]; ids?: CampagneUserRelationsIds; }>(),
    'Upsert Many Campagne Users Success': props<{ campagneUsers: CampagneUserEntityState[] }>(),
    'Delete One Campagne User': props<{ idCampagneUser: number }>(),
    'Delete One Campagne User Success': props<{ idCampagneUser: number }>(),
    'Normalize Many Campagne Users After Upsert': props<{ campagneUsers: CampagneUserEntityState[] }>(),
    'Campagne Users Failure': props<{ error: HttpErrorResponse }>(),
    'Clear Campagne Users': emptyProps(),
    'Add User Success': props<{ idCampagneUser: number; idUser: number }>(),
    'Delete Many User Success': props<{ idUsers: number[]; idCampagneUsers: number[] }>(),
    'Add Campagne Success': props<{ idCampagneUser: number; idCampagne: number }>(),
    'Delete Many Campagne Success': props<{ idCampagnes: number[]; idCampagneUsers: number[] }>()
  }
});
